import TabSwitcherWeb from "@components/switcher/TabSwitcherWeb";
import AccountApprovals from "./AccountApprovals";
import CurrentAffiliates from "./CurrentAffiliates";
import MerchantApprovalMapping from "./MerchantApprovalMapping";

const AffiliateManagement = () => {
  const affiliateTabs = [
    { label: "ACCOUNT APPROVALS", component: <AccountApprovals /> },
    {
      label: "MERCHANT MAPPING APPROVALS",
      component: <MerchantApprovalMapping />,
    },
    { label: "CURRENT AFFILIATES", component: <CurrentAffiliates /> },
  ];
  return (
    <>
      <div className="h-[70px] border-b border-border-subtle bg-bg-page-body flex flex-row sticky top-0 bg-white z-10 pl-[20px] w-full">
        <p className="flex text-text-base text-[14px] font-semibold items-center">
          Affiliate Management
        </p>
      </div>
      <div className="flex justify-start mx-4 mt-[20px]">
        <TabSwitcherWeb tabs={affiliateTabs} full={true} />
      </div>
    </>
  );
};

export default AffiliateManagement;
